<template>
  <div class="page">
    <h2>用户评价管理</h2>
    <div class="toolbar">
      <input v-model.number="filters.therapyId" type="number" placeholder="活动ID" />
      <input v-model.number="filters.therapistId" type="number" placeholder="理疗师ID" />
      <select v-model.number="filters.rating">
        <option :value="null">全部评分</option>
        <option v-for="i in 5" :key="i" :value="i">{{ i }}星</option>
      </select>
      <button :disabled="loading" @click="loadData">查询</button>
    </div>
    <table>
      <thead>
        <tr><th>ID</th><th>评分</th><th>内容</th><th>回复</th><th>可见</th><th>操作</th></tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.rating }}</td>
          <td>{{ item.content || '-' }}</td>
          <td>{{ item.adminReply || '-' }}</td>
          <td>{{ item.isVisible ? '是' : '否' }}</td>
          <td>
            <button :disabled="loading" @click="toggle(item)">{{ item.isVisible ? '隐藏' : '显示' }}</button>
            <button :disabled="loading" @click="openReply(item)">回复</button>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="replyDialog" class="dialog-mask">
      <div class="dialog">
        <h3>回复评价</h3>
        <textarea v-model="replyText" rows="4" placeholder="输入回复内容"></textarea>
        <div class="actions">
          <button :disabled="loading" @click="replyDialog=false">取消</button>
          <button :disabled="loading" @click="submitReply">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { therapyReviewService } from '@/services/therapyReviewService'

export default {
  name: 'TherapyReviewManagement',
  data() {
    return {
      list: [],
      filters: { therapyId: null, therapistId: null, rating: null },
      replyDialog: false,
      replyText: '',
      replyId: null,
      loading: false
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await therapyReviewService.fetchList({ ...this.filters, size: 100 })
        this.list = res.data?.content || []
      } catch (e) {
        alert(e?.response?.data?.error || '加载评价失败')
      } finally {
        this.loading = false
      }
    },
    async toggle(item) {
      this.loading = true
      try {
        await therapyReviewService.setVisibility(item.id, !item.isVisible)
        await this.loadData()
      } catch (e) {
        alert(e?.response?.data?.error || '更新可见性失败')
      } finally {
        this.loading = false
      }
    },
    openReply(item) {
      this.replyId = item.id
      this.replyText = item.adminReply || ''
      this.replyDialog = true
    },
    async submitReply() {
      this.loading = true
      try {
        await therapyReviewService.reply(this.replyId, this.replyText)
        this.replyDialog = false
        await this.loadData()
      } catch (e) {
        alert(e?.response?.data?.error || '回复失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar select,
.toolbar input {
  height: 40px;
}
.toolbar select {
  min-width: 120px;
}
</style>

